import styled from 'styled-components';

export const AccordionPanel = styled.div`
  margin: 0;
  padding: 24px 0;
  position: relative;
  overflow: hidden;
  display: block;
`;
